module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.75de32d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/font/AmwayIcons.ttf?5v2gxx
// module id = YnjR
// module chunks = 0